module.exports = __webpack_public_path__ + "static/media/sponcer_CEW.d4fd5932.svg";